
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { UtensilsCrossed, Monitor, Wifi, ShoppingCart, ChefHat, Receipt, BarChart3, Settings, ChevronRight, Clock, Users, Star, Sparkles } from 'lucide-react';
import '../styles/SharedStyles.css';

const rtFeatures = [
  {
    icon: ShoppingCart,
    title: 'Smart Ordering',
    description: 'Streamline orders from table to kitchen with real-time tracking and automated workflows.',
    color: '#f59e0b'
  },
  {
    icon: ChefHat,
    title: 'Kitchen Display',
    description: 'Digital kitchen display system that prioritizes orders and reduces preparation time.',
    color: '#ef4444'
  },
  {
    icon: Receipt,
    title: 'POS Integration',
    description: 'Seamless point-of-sale integration with inventory management and payment processing.',
    color: '#10b981'
  },
  {
    icon: BarChart3,
    title: 'Analytics Dashboard',
    description: 'Real-time insights into sales, customer trends, and operational performance.',
    color: '#6366f1'
  },
  {
    icon: Wifi,
    title: 'IoT Connectivity',
    description: 'Connect smart devices, sensors, and equipment for automated monitoring and alerts.',
    color: '#0ea5e9'
  },
  {
    icon: Monitor,
    title: 'Digital Menu Boards',
    description: 'Dynamic digital menus that update in real-time with pricing, availability, and promotions.',
    color: '#8b5cf6'
  },
  {
    icon: Clock,
    title: 'Reservation System',
    description: 'Manage table reservations, waitlists, and seating optimization effortlessly.',
    color: '#ec4899'
  },
  {
    icon: Settings,
    title: 'Operations Hub',
    description: 'Centralized management for staff scheduling, compliance, and maintenance tracking.',
    color: '#14b8a6'
  }
];

const stats = [
  { value: '40%', label: 'Faster Service' },
  { value: '25%', label: 'Cost Reduction' },
  { value: '99.9%', label: 'Uptime' },
  { value: '500+', label: 'Restaurants' }
];

const RTSystem = () => {
  const { t } = useLanguage();
  const { isActive, isAdmin } = useAuth();
  const { theme } = useTheme();

  return (
    <div className={`shared-page ${theme}`}>
      <div className="glow-effect glow-1"></div>
      <div className="glow-effect glow-2"></div>
      <div className="container shared-content" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>

        <div className="shared-section-header">
          <h2>
            <UtensilsCrossed size={28} />
            Restaurant Technology
          </h2>
          <p>Next-generation technology solutions for modern restaurants</p>
        </div>

        {/* Stats Section */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1.5rem',
          marginBottom: '3rem',
          animation: 'slideUp 0.8s ease-out forwards',
          opacity: 0
        }}>
          {stats.map((stat, index) => (
            <div key={index} className="shared-feature-card" style={{
              '--card-color': '#f59e0b',
              textAlign: 'center',
              minHeight: 'auto',
              padding: '1.5rem',
              animationDelay: `${index * 0.1}s`
            }}>
              <div style={{ fontSize: '2rem', fontWeight: 800, background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                {stat.value}
              </div>
              <div style={{ color: '#94a3b8', fontSize: '0.875rem', marginTop: '0.25rem' }}>{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="shared-grid">
          {rtFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="shared-feature-card" style={{ '--card-color': feature.color, animationDelay: `${0.1 + index * 0.1}s` }}>
                <div className="shared-card-icon" style={{ backgroundColor: feature.color }}>
                  <Icon size={28} />
                </div>
                <h3>{feature.title}</h3>
                <p className="shared-card-desc">{feature.description}</p>
                <a href="#" className="shared-card-link" onClick={(e) => e.preventDefault()}>
                  Learn More
                  <ChevronRight size={16} />
                </a>
                <div className="shared-card-arrow">
                  <ChevronRight size={20} />
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default RTSystem;
